
var sprite = require("/harness/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 31 31\" id=\"arrow-circle-left.f6e62691\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <style type=\"text/css\"> #arrow-circle-left.f6e62691 .st0{fill:#51BFBB;} </style> <g> <path class=\"st0\" d=\"M15.5,0C24,0,31,7,31,15.5S24,31,15.5,31S0,24,0,15.5S7,0,15.5,0z M15.5,30c8,0,14.5-6.5,14.5-14.5\r\n\t\tS23.5,1,15.5,1S1,7.5,1,15.5S7.5,30,15.5,30z\"/> </g> <g> <path class=\"st0\" d=\"M18.2,8.1c0.1,0,0.3,0,0.4,0.1c0.2,0.2,0.2,0.5,0,0.7L12,15.5l6.6,6.6c0.2,0.2,0.2,0.5,0,0.7s-0.5,0.2-0.7,0\r\n\t\tl-6.6-6.6C11.1,16,11,15.7,11,15.5s0.1-0.5,0.3-0.6l6.6-6.6C18,8.1,18.1,8.1,18.2,8.1z\"/> </g> </symbol>";
module.exports = sprite.add(image, "arrow-circle-left.f6e62691");


//////////////////
// WEBPACK FOOTER
// ./assets/icons/arrow-circle-left.svg
// module id = 1788
// module chunks = 0